module.exports = __webpack_public_path__ + "img/india.865b8563.svg";